import { CloudinaryMediaAsset } from "../../../models";

export class MultipleChoiceQuestionOption {
    constructor (
        public id : number,
        public value : any,
        public help : string,
        public media : CloudinaryMediaAsset
    ){}
}